__turbopack_context__.v({
  "address": "contactAddress-module__LSn9pq__address",
  "addressColumn": "contactAddress-module__LSn9pq__addressColumn",
  "container": "contactAddress-module__LSn9pq__container",
  "content": "contactAddress-module__LSn9pq__content",
  "heading": "contactAddress-module__LSn9pq__heading",
  "mapContainer": "contactAddress-module__LSn9pq__mapContainer",
  "textGroup": "contactAddress-module__LSn9pq__textGroup",
  "title": "contactAddress-module__LSn9pq__title",
});
